import type { ComponentProps } from "react";
import { cn } from "../lib/cn";

const VARIANTS = {
  primary: "bg-emerald-600 text-white hover:bg-emerald-500",
  secondary: "bg-zinc-700 text-zinc-100 hover:bg-zinc-600",
  danger: "bg-red-700 text-white hover:bg-red-600",
  ghost: "bg-transparent text-zinc-300 hover:bg-zinc-800",
} as const;

export function Button({
  variant = "secondary",
  size = "md",
  className,
  ...props
}: ComponentProps<"button"> & { variant?: keyof typeof VARIANTS; size?: "sm" | "md" }) {
  return (
    <button
      type="button"
      className={cn(
        "inline-flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50",
        size === "sm" ? "h-7 px-2 text-xs" : "h-9 px-3 text-sm",
        VARIANTS[variant],
        className,
      )}
      {...props}
    />
  );
}
